<template>
    <Modal :show="true" @close="close">
        <form class="flex flex-col space-y-4" @submit.prevent="submit">
            <form-body
                v-model="form"
                :fields="props.fields"
                :reservables="props.reservables"
                :domains="domains"
            ></form-body>

            <fieldset class="forms__actions">
                <div class="flex space-x-8">
                    <div class="flex-auto text-center">
                        <Button
                            type="submit"
                            :class="{ 'opacity-75': form.processing }"
                            :loading="form.processing"
                            :disabled="form.processing"
                            dusk="form-submit"
                            color="primary"
                        >
                            {{ lang('reservations::slots.actions.create') }}
                        </Button>
                    </div>
                </div>
            </fieldset>
        </form>
    </Modal>
</template>

<script setup lang="ts">
import { useForm } from '@inertiajs/vue3';
import { Reservable } from '@src/Reservations/Pages/types';
import FormBody from '@src/Reservations/Pages/Reservables/FormBody.vue';

interface Props {
    reservables?: Reservable[];
    domains: any[];
    fields: any;
}

const props = withDefaults(defineProps<Props>(), {
    reservables: () => [],
});

const emit = defineEmits(['close', 'created']);

const close = () => {
    emit('close');
};

const form = useForm({
    parent_id: null,
    name: null,
    domain: null,
});

const submit = () => {
    form.post(route('reservations/reservables.admin.api.create'), {
        preserveScroll: true,
        preserveState: true,
        forceFormData: true,
        onSuccess: () => emit('created'),
        onStart: () => ({}),
        onFinish: () => emit('close'),
    });
};
</script>
